import SaleFormComponent from 'components/forms/sale';
import {Form, Formik} from 'formik';
import Header from 'modules/header/wholesaler/main';
import Description from 'pages/farm/createAd/form/owner/sale/description';
import {formDataCreator} from '../../utilities/formDataCreatot';
import {initialValues, initialValuesCreator} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import usePostEditAd from '../../hooks/usePostEditAd';
import useSetAnswers from 'pages/farm/createAd/form/owner/simple/hooks/useSetAnswers';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import {useFarm} from 'context/farmContext';
import usePostEditDetail from '../../hooks/usePostEditDetail';

const SaleForm = () => {
  const {guid} = useParams();

  const {farm} = useFarm();
  const {isLoading, mutate} = usePostEditAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const {productDetail} = useGetPostDetail(guid || '');
  const {postEditDetail} = usePostEditDetail(guid || '');

  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <Description />
      <Formik
        initialValues={
          productDetail
            ? initialValuesCreator(productDetail, postEditDetail)
            : initialValues
        }
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, farm, guid);
          payload.append('price', values.price);
          payload.append('min_price', values.min_price);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          payload.append('decline_rate', values.decline_rate);
          payload.append('rate_unit', values.rate_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
        }}
      >
        {({values}) => (
          <Form className="px-3">
            <SaleFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={farm?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SaleForm;
